import { z } from 'zod'

/**
 * `LGH-034`. Console's own vocabulary for `OnboardingRequest` — kept
 * distinct from the contract schema in `contract-read.ts` for the same
 * reason every other console type here is: a translation step gives this
 * side somewhere to stand if the wire changes without the console needing
 * to, and it's where `ACCEPTED_NAMED`/`ACCEPTED_MERGED`'s Prisma-style
 * casing becomes this codebase's own camelCase.
 */
export const onboardingRequestStatusSchema = z.enum([
  'pending',
  'acceptedNamed',
  'acceptedMerged',
  'rejected',
])
export type OnboardingRequestStatus = z.infer<typeof onboardingRequestStatusSchema>

export const onboardingRequestChannelSchema = z.enum(['phone', 'email'])
export type OnboardingRequestChannel = z.infer<typeof onboardingRequestChannelSchema>

export const onboardingRequestSchema = z
  .object({
    id: z.string(),
    sender: z.object({ channel: onboardingRequestChannelSchema, value: z.string() }),
    messageText: z.string(),
    attachment: z.object({ sha256: z.string(), sizeBytes: z.number() }).nullable(),
    qrSourceContext: z.string().nullable(),
    status: onboardingRequestStatusSchema,
    createdAt: z.string(),
    decidedAt: z.string().nullable(),
    decidedByStaffId: z.string().nullable(),
    resultingTenantId: z.string().nullable(),
  })
  .strict()
export type OnboardingRequest = z.infer<typeof onboardingRequestSchema>

export const onboardingRequestListSchema = z.array(onboardingRequestSchema)

export const acceptNamedRequestSchema = z.object({ tenantName: z.string().min(1) })
export type AcceptNamedRequest = z.infer<typeof acceptNamedRequestSchema>

export const requestMergeOtpRequestSchema = z.object({ tenantId: z.string().min(1) })

export const confirmMergeOtpRequestSchema = z.object({
  tenantId: z.string().min(1),
  otp: z.string().min(1),
})
